<template>
<div id="ficheIncident" class="modal_container">
  <div class="modal_background">
    <div class="modal">
      <div class="modal_header">
        <div :class="pinStyle">TNT</div>
        <h3>Détails émetteur TNT</h3>
        <span class="icon_close" @click="closeModal()"></span>
      </div>
      <!-- ================= Modale incident en cours ================= -->
      <div class="modal_content" v-if="incident">
        <div class="tnt_text tnt_text_out" v-if="incident.incidentEnCours">Un incident a été détecté sur cet émetteur</div>
        <div class="resume">
          <div class="group">
            <label>Nom de l'émetteur : </label>
            <p>{{incident.nomEmetteur}}</p>
          </div>
          <div class="group">
            <label>Date de début de l'incident :</label>
            <p>{{incident.dateDebut}}</p>
          </div>
          <div class="group">
            <label>Date de signalement :</label>
            <p>{{incident.dateSignalement}}</p>
          </div>
          <div class="group">
            <label>Multiplex :</label>
            <p>{{incident.multiplex}}</p>
          </div>
          <div class="group">
            <label>Canaux :</label>
            <p>{{incident.canaux}}</p>
          </div>
          <div class="group">
            <label>Diffuseur :</label>
            <p>{{incident.diffuseur}}</p>
          </div>
        </div>
        <div class="local_chanels">
          <h3>Caractéristiques de l'incident :</h3>
          <p class="caracteristiques"> {{incident.syntheseDossier}} </p>
        </div>
      </div>
      <!-- ================= Modale emetteur actif ================= -->
      <div class="modal_footer">
        <button @click="closeModal()" class="button dark">Fermer</button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import moment from 'moment'
export default {
  name: 'FicheIncident',
  components: {},
  data() {
    return {
      tnt: null,
      nomEmetteur: null,
      pinStyle: null,
      incidentEnCours: false,
      incident: null,
      listeMultiplexes: null,
      multiplexChaines: []
    }
  },
  created() {},
  destroyed() {},
  computed: {
    getDateDebut() {
      return moment(new Date(this.incident.dateDebut)).format('DD/MM/YYYY');
    },
    getDateSignalement() {
      return moment(new Date(this.incident.dateSignalement)).format('DD/MM/YYYY');
    },
  },
  filters: {
    printArray(value) {
      return value.toString().replace(/\[/g, "").replace(/]/g, "").replace(/(,(?=\S)|:)/g, ", ");
    },
    printDate(value) {
      return (value != null) ? moment(new Date(value)).format('DD/MM/YYYY') : null;
    },
    handleMissingValue(value) {
      return (value != null && value.length > 0) ? value : "Non renseigné";
    }
  },
  mounted: function() {},
  methods: {
    loadIncident(incident) {
      if (incident) {
        this.incident = incident
        this.determinePinStyle(this.incident.incidentEnCours);
        this.openModal()
      }
    },
    openModal() {
      var modal = document.getElementById('ficheIncident')
      var body = document.getElementsByTagName('body')[0]
      modal.classList.add('animation');
      body.classList.add('modal_active');
    },
    closeModal() {
      var modal = document.getElementById('ficheIncident');
      var body = document.getElementsByTagName('body')[0];
      modal.classList.remove('animation')
      body.classList.remove('modal_active')
    },
    /**
     * Style CSS de l'icône CSS de l'émetteur
     */
    determinePinStyle(hasUnresolvedIncident) {
      let style = "pin pin_tnt ";
      if (hasUnresolvedIncident) {
        this.pinStyle = style + "tnt_out";
      } else {
        this.pinStyle = style;
      }
    }
  }
}
</script>

<style>
.modal_header {
  border-bottom: 0px solid rgb(220, 220, 220);
}

.caracteristiques {
  text-indent: 5%;
}

.group label {
  margin-top: 10px;
}

.chaine {
  border: 1px solid #81d1db;
  padding: 0;
  height: 50px;
  margin-bottom: 10px;
}

.nomChaine {
  background-color: #81d1db;
  color: white;
  width: 40px;
  font-weight: 600;
  line-height: 48px;
  text-align: center;
}

.listeChaines {
  display: flex;
  margin-left: 5px;
  align-items: center;
}

.listeChaines div {
  margin-right: 10px;
}

.listeChaines img {
  height: 20px;
  transform: translate(0, 25%);
}
</style>
